import { render, staticRenderFns } from "./dealerCustomerInfo.vue?vue&type=template&id=636bed7a"
import script from "./dealerCustomerInfo.vue?vue&type=script&lang=js"
export * from "./dealerCustomerInfo.vue?vue&type=script&lang=js"
import style0 from "./dealerCustomerInfo.vue?vue&type=style&index=0&id=636bed7a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports